module.exports = __webpack_public_path__ + "img/project_detail_bg.7aa014c3.png";